import React,{useState} from 'react'

export const useStore = () => {
    const cart = useState([])
    const selected = useState(null)
    return [...cart,...selected]
}